export default __webpack_public_path__ + "static/media/a.aa4074c8.png";